<template>
  <form @submit.prevent="save">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Add {{ platform.name }} Integration</p>
      </header>
      <section class="modal-card-body">
        <div class="has-text-centered">
          <b-image :src="platform.logo_url" ratio="3x1" :responsive="false" />
        </div>
        <b-field label="API Key" >
          <b-input v-model="apiKey" size="is-medium"></b-input>
        </b-field>
        <b-field label="API Secret" >
          <b-input v-model="apiSecret" size="is-medium"></b-input>
        </b-field>
        <b-field label="Tag ID (optional)" >
          <b-input v-model="tagId" size="is-medium"></b-input>
        </b-field>
      </section>
      <footer class="modal-card-foot space-between">
        <button class="button" type="button" @click="$emit('canceled')">Back</button>
        <b-button
          type="is-primary"
          native-type="submit"
          :loading="saving"
          :disabled="!ready || saving"
        >Add Integration</b-button>
      </footer>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['context']),
    endpoint () {
      return this.context.route + '/platform-accounts/'
    },
    json () {
      const json = {
        platform: { code: this.platform.code },
        credentials: [{
          credential: { code: 'shipstation_api_key' },
          value: this.apiKey
        }, {
          credential: { code: 'shipstation_api_secret' },
          value: this.apiSecret
        }]
      }
      if (this.tagId) {
        json.credentials.push({
          credential: { code: 'shipstation_tag_id' },
          value: this.tagId
        })
      }
      return json
    },
    ready () {
      return this.apiKey && this.apiSecret
    }
  },
  data () {
    return {
      apiKey: null,
      apiSecret: null,
      webhookSecret: null,
      tagId: null,
      saving: false,
      errors: {}
    }
  },
  methods: {
    save () {
      this.saving = true
      this.$http.post(this.endpoint, this.json).then(response => {
        this.$emit('account:saved')
      }).catch(error => {
        if (error.response && error.response.status === 400) {
          this.errors = { detail: 'Please review your input and try again.' }
        }
      }).finally(() => {
        this.saving = false
      })
    }
  },
  props: ['platform']
}
</script>
